module.exports = __webpack_public_path__ + "static/img/22.7868aa5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/zh/22.png
// module id = lfOT
// module chunks = 0